import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
// eslint-disable-next-line no-unused-vars
export default function getServiceLevels(_x) {
  return _getServiceLevels.apply(this, arguments);
}

function _getServiceLevels() {
  _getServiceLevels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, groupId, userId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, groupId = _ref.groupId, userId = _ref.userId;
            return _context.abrupt("return", app.functions().httpsCallable('getServiceLevels')({
              groupId: groupId,
              userId: userId || undefined
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getServiceLevels.apply(this, arguments);
}